import { MessageCircle } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { fetchSettings } from "@/lib/queries";
import { trackWhatsAppClick } from "@/lib/analytics";

export function WhatsAppFab() {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: fetchSettings });
  const url = data?.contact?.whatsapp_url;
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      aria-label="Hablar por WhatsApp"
      onClick={() => trackWhatsAppClick("fab")}
      className="fixed bottom-24 right-4 z-30 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[oklch(0.7_0.17_150)] text-white shadow-elevated ring-1 ring-white/10 transition hover:scale-105 md:bottom-6"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
